import React, {useContext, useEffect, useRef, useState} from 'react';
import {toast} from "react-toastify";
import {createPool, getPoolsCurrentUser} from "../../http/poolAPI";
import {Context} from "../../index";
import AvatarEditor from 'react-avatar-editor';
import defaultImage from "../../assets/empty-cover.jpg";
import {Dropdown, Form} from "react-bootstrap";
import 'react-quill/dist/quill.snow.css'; // стили для Quill




const MAX_POLL_FULL_IMAGE_SIDE = 2400;

const CreatePool = () => {
    const [loading, setLoading] = useState(false);
    const [, setError] = useState('');
    const [poolName, setPoolName] = useState('');
    const [poolDescription] = useState('');
    const [poolQuestion, setPoolQuestion] = useState('');
    const [poolType, setPoolType] = useState('COVER_POLL');
    const [poolLanguage, setPoolLanguage] = useState('English');
    const [poolPrice] = useState('');
    const [poolMessage] = useState('');
    const [poolItemCount, setPoolItemCount] = useState(2);
    const [items, setItems] = useState(
        Array.from({ length: 8 }, () => ({
            title: '',
            desc: '',
            addition: '',
            pn: '',
            average_rating: 0,
            flag: false,
            image: null, // File
            originalFile: null,
            sourceFile: null,
            preview: defaultImage,
            showEditor: false,
            scale: 1,
            editorRef: null,
            format: '6x9',
            editorSize: { width: 200, height: 300 },
        }))
    );
    const {user} = useContext(Context);
    const { poolStore } = useContext(Context);
    const username = user?.user?.username || '';
    const [writeOwnName, setWriteOwnName] = useState(false);

    const languages = [
        { id: 1, name: 'English' },
        { id: 2, name: 'Spanish' },
        { id: 3, name: 'German' }
    ];

    const questions = [
        // Cover poll (по обложке)
        { id: 1, type: 'COVER_POLL', name: 'Which book cover do you prefer, and why?', short_name: 'Cover: Which Cover' },
        { id: 2, type: 'COVER_POLL', name: 'What do you like most about this book cover?', short_name: 'Cover: Like About Cover' },
        { id: 3, type: 'COVER_POLL', name: 'Would you choose this book based on the cover alone? Why or why not?', short_name: 'Cover: Cover Choice' },
        { id: 4, type: 'COVER_POLL', name: 'What emotions or impressions does this cover give you?', short_name: 'Cover: Emotions' },
        { id: 5, type: 'COVER_POLL', name: 'Does this cover look professional and appealing to you? Why or why not?', short_name: 'Cover: Professional Appeal' },

        // Title poll (по тайтлу и автору)
        { id: 6, type: 'TITLE_POLL', name: 'Which book title do you prefer, and why?', short_name: 'Title: Which Title' },
        { id: 7, type: 'TITLE_POLL', name: 'Does the title accurately reflect the book\'s theme or genre?', short_name: 'Title: Title Reflect' },
        { id: 8, type: 'TITLE_POLL', name: 'Do you think the title will attract your interest to read the book? Why or why not?', short_name: 'Title: Title Attraction' },
        { id: 9, type: 'TITLE_POLL', name: 'What do you think of the author\'s name in relation to the title? Does it add credibility to the book?', short_name: 'Title: Author Title' },

        // Description poll (по описанию)
        { id: 10, type: 'DESCRIPTION_POLL', name: 'Which book description do you prefer, and why?', short_name: 'Description: Which Description' },
        { id: 11, type: 'DESCRIPTION_POLL', name: 'Does the description make you want to read the book? Why or why not?', short_name: 'Description: Description Desire' },
        { id: 12, type: 'DESCRIPTION_POLL', name: 'Which description provides the clearest idea of the book\'s plot?', short_name: 'Description: Clear Description' },
        { id: 13, type: 'DESCRIPTION_POLL', name: 'Does the description leave you curious or confused about the book? Explain why.', short_name: 'Description: Curious Description' },

        // Cover + Title poll (комбинированные вопросы)
        { id: 14, type: 'COVER_TITLE_POLL', name: 'Which combination of cover and title do you prefer, and why?', short_name: 'Cover&Title: Preferred Combo' },
        { id: 15, type: 'COVER_TITLE_POLL', name: 'Does the title match the tone or style suggested by the cover? Explain.', short_name: 'Cover&Title: Match Tone' },
        { id: 16, type: 'COVER_TITLE_POLL', name: 'Would the combination of this cover and title make you stop and look at the book?', short_name: 'Cover&Title: Attention Grabber' },
        { id: 17, type: 'COVER_TITLE_POLL', name: 'What impression does the cover and title together give about the book\'s genre or content?', short_name: 'Cover&Title: Impression' },

        // Mixed poll (всё вместе — обложка, титул и описание)
        { id: 18, type: 'MIXED_POLL', name: 'Which book do you find most appealing overall (cover, title, and description), and why?', short_name: 'Mixed: Overall Appeal' },
        { id: 19, type: 'MIXED_POLL', name: 'If you had to pick a book from the three, which one would it be based on the combination of the cover, title, and description?', short_name: 'Mixed: Pick Based on All' },
        { id: 20, type: 'MIXED_POLL', name: 'Which combination of cover, title, and description do you think would attract more readers?', short_name: 'Mixed: Best Combo' },

    ];



    const editorRefs = useRef([]);

    const [activeIndex, setActiveIndex] = useState(null); // Состояние для активного индекса

    // Функция для получения текущей даты в нужном формате
    const getCurrentDate = () => {
        const date = new Date();
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleDateString('en-GB', options); // 25-Apr-2025
    };

    // Используем useEffect для установки начального значения poolName
    useEffect(() => {
        const currentDate = getCurrentDate(); // Получаем текущую дату
        if (!writeOwnName) {
            switch (poolType) {
                case 'COVER_POLL':
                    setPoolName(`Cover Poll by ${username} with ${poolItemCount} Options, ${currentDate}`);
                    break;
                case 'TITLE_POLL':
                    setPoolName(`Title Poll by ${username} with ${poolItemCount} Options, ${currentDate}`);
                    break;
                case 'COVER_TITLE_POLL':
                    setPoolName(`Cover & Title Poll by ${username} with ${poolItemCount} Options, ${currentDate}`);
                    break;
                case 'DESCRIPTION_POLL':
                    setPoolName(`Description Poll by ${username} with ${poolItemCount} Options, ${currentDate}`);
                    break;
                case 'MIXED_POLL':
                    setPoolName(`Mixed Poll by ${username} with ${poolItemCount} Options, ${currentDate}`);
                    break;
                default:
                    setPoolName('');
            }
        }
    }, [poolType, writeOwnName, poolItemCount, username]);

     const addPool = async () => {
         if (!poolType) {
             toast.error(`Provide a Type for this Poll!`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
             return;
         }
        if (!poolName) {
            toast.error(`Provide a Name for this Poll!`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
         if (!poolQuestion) {
             toast.error(`Set Question for Respondents!`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
             return;
         }
         for (let i = 0; i < poolItemCount; i++) {
             const item = items[i];
             if (!item.title && (poolType === 'TITLE_POLL' || poolType === 'MIXED_POLL' || poolType === 'COVER_TITLE_POLL')) {
                 toast.error(`Set Title #${i + 1}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                 return;
             }
             if (!item.pn && (poolType === 'TITLE_POLL' || poolType === 'MIXED_POLL' || poolType === 'COVER_TITLE_POLL')) {
                 toast.error(`Set Author Name #${i + 1}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                 return;
             }
             if (!item.desc && (poolType === 'DESCRIPTION_POLL' || poolType === 'MIXED_POLL')) {
                 toast.error(`Set Description #${i + 1}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                 return;
             }
             if (!item.image && (poolType === 'COVER_POLL' || poolType === 'MIXED_POLL' || poolType === 'COVER_TITLE_POLL')) {
                 toast.error(`Upload Image #${i + 1}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                 return;
             }
         }

         setLoading(true);
         setError('');

        try {
            const formData = new FormData();

            formData.append('userId', user?.user?.id);
            formData.append('name', poolName);
            formData.append('description', poolDescription);
            formData.append('question', poolQuestion);
            formData.append('owner', user?.user?.amz_name);
            formData.append('pool_type', poolType || 'COVER_POLL');
            formData.append('language', poolLanguage);
            formData.append('pool_price', poolPrice);
            formData.append('status', 'LIVE');
            formData.append('message', poolMessage);
            formData.append('default_price', poolItemCount * 100);
            formData.append('default_decrement', poolItemCount * 10);

            // Добавляем Poll items (до 8)
            for (const [index, item] of items.entries()) {
                const i = index + 1;
                // Преобразуем Blob в File перед отправкой
                if (item.image) {
                    const blob = item.image;  // Получаем Blob из массива

                    // Проверяем, что item.image действительно является Blob
                    if (blob instanceof Blob) {
                        // Преобразуем Blob в файл с нужным расширением (например, .jpg)
                        const file = new File([blob], `image-${i}.jpg`, { type: "image/jpeg" });
                        console.log("All good", file);
                        if (item.sourceFile instanceof Blob) {
                            const fullBlob = await createFullPollImageBlob(item.sourceFile);
                            const fullFile = new File([fullBlob], `image-${i}-full.jpg`, { type: "image/jpeg" });
                            formData.append(`pool_item${i}_image_full`, fullFile);
                        }
                        // Добавляем файл в FormData
                        formData.append(`pool_item${i}_image`, file);  // pool_item${i}_image — это имя поля
                    } else {
                        console.error("item.image is not a Blob");
                    }
                }
                formData.append(`pool_item${i}_title`, item.title || '');
                formData.append(`pool_item${i}_desc`, item.desc || '');
                formData.append(`pool_item${i}_addition`, item.addition || '');
                formData.append(`pool_item${i}_pn`, item.pn || '');
                formData.append(`pool_item${i}_average_rating`, item.average_rating || 0);
                formData.append(`pool_item${i}_flag`, item.flag || false);
            }


            const response = await createPool(formData);
            toast.success(response.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setTimeout(() => {
            if (user?.user?.id) {
                getPoolsCurrentUser(user.user.id)
                    .then((data) => {
                        poolStore.setCurrentUserPools(data);

                        // Находим максимальный id в полученных пулах
                        const maxId = data.reduce((max, item) => {
                            const itemId = Number(item.id);
                            return itemId > max ? itemId : max;
                        }, 0);

                        // Ищем сам пул с этим максимальным id
                        const selectedPool = data.find(item => Number(item.id) === maxId);

                        // Устанавливаем его в стор
                        if (selectedPool) {
                            poolStore.setSelectedPool(selectedPool);
                        }
                    })
                    .catch((err) => console.error("❌ Error:", err));
            }
            }, 250);

            return response;
        } catch (e) {
            toast.error(`❌ Error creating Poll: ${e.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            const errorMessage = e.response?.data?.message || 'An error occurred while adding the Poll.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = (index) => {
        const editor = editorRefs.current[index];
        if (editor) {
            // Получаем изображение с учётом масштаба
            const canvas = editor.getImageScaledToCanvas();

            // Получаем текущий масштаб из состояния
            const scaleFactor = items[index].scale;

            // Применяем масштаб для сохранения изображения
            const width = canvas.width * scaleFactor;
            const height = canvas.height * scaleFactor;

            // Создаём Blob изображения с учётом масштаба
            canvas.toBlob((blob) => {
                const newEditors = [...items];
                newEditors[index] = {
                    ...newEditors[index],
                    originalFile: blob, // Сохраняем редактированное изображение
                    preview: URL.createObjectURL(blob), // Преобразуем Blob в URL для отображения
                    width: width, // Сохраняем обновлённый размер
                    height: height, // Сохраняем обновлённый размер
                    showEditor: false,
                    image: blob,
                    flag: true,
                };
                setItems(newEditors); // Обновляем состояние редакторов


                console.log("New items array after saving image:", newEditors); // Проверяем, что записалось в новый массив


            }, "image/jpeg", 0.92);
        }
    };








    const createFullPollImageBlob = (file) => {
        return new Promise((resolve, reject) => {
            const image = new window.Image();
            const objectUrl = URL.createObjectURL(file);

            image.onload = () => {
                try {
                    const naturalWidth = image.naturalWidth || image.width;
                    const naturalHeight = image.naturalHeight || image.height;
                    const ratio = Math.min(1, MAX_POLL_FULL_IMAGE_SIDE / Math.max(naturalWidth, naturalHeight));
                    const width = Math.max(1, Math.round(naturalWidth * ratio));
                    const height = Math.max(1, Math.round(naturalHeight * ratio));
                    const canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(image, 0, 0, width, height);
                    canvas.toBlob((blob) => {
                        URL.revokeObjectURL(objectUrl);
                        if (blob) resolve(blob);
                        else reject(new Error("Could not prepare full-size poll image."));
                    }, "image/jpeg", 0.95);
                } catch (err) {
                    URL.revokeObjectURL(objectUrl);
                    reject(err);
                }
            };

            image.onerror = () => {
                URL.revokeObjectURL(objectUrl);
                reject(new Error("Could not read uploaded poll image."));
            };

            image.src = objectUrl;
        });
    };

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];


        e.target.value = "";

        if (file && file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const newEditors = [...items];
                newEditors[index].originalFile = file;
                newEditors[index].sourceFile = file;
                newEditors[index].preview = event.target.result;
                newEditors[index].showEditor = true;
                setItems(newEditors);
                setActiveIndex(index);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDelete = (index) => {
        const newEditors = [...items];
        newEditors[index] = {
            title: '',
            desc: '',
            addition: '',
            pn: '',
            average_rating: 0,
            flag: false,
            image: null,
            originalFile: null,
            sourceFile: null,
            preview: defaultImage,
            showEditor: false,
            scale: 1,
            editorRef: null,
            format: '6x9',
            editorSize: { width: 200, height: 300 },
        };
        setItems(newEditors);

    };

    const handleScaleChange = (e, index) => {
        const newEditors = [...items];
        newEditors[index].scale = parseFloat(e.target.value);
        setItems(newEditors);
    };

    const handleFormatChange = (index, newFormat) => {
        setItems(prev => {
            const updatedEditors = [...prev];
            const newSize = calculateEditorSize(newFormat);

            updatedEditors[index] = {
                ...updatedEditors[index],
                format: newFormat,
                editorSize: newSize, // Обновляем размеры
            };

            return updatedEditors;
        });
    };

    const calculateEditorSize = (format) => {
        const sizes = {

                "6x9": { width: 200, height: 300 },
                "8.5x11": { width: 283.33, height: 366.67 },
                "8.5x8.5": { width: 283.33, height: 283.33 },
                "8x10": { width: 266.67, height: 333.33 },
                "5x8": { width: 166.67, height: 266.67 },
                "7x10": { width: 233.33, height: 333.33 },

        };

        // Возвращаем размер по ключу формата или дефолтное значение, если формат не найден
        return sizes[format] || { width: 200, height: 300 }; // Значение по умолчанию
    };


    return (
        <div className="card text-center align-content-center shadow-sm mt-2 mb-0 p-3" style={{ width: '100%' }}>
            <h5 className="justify-content-start text-start text-muted fst-italic p-1 mb-0">
                Create a New Poll:
            </h5>
            <p
                className="text-muted small text-start ms-1 mb-3"
                style={{ lineHeight: '1.2' }} // можно поиграть с числом: 1.0 — плотнее, 1.2 — чуть свободнее
            >
                You can create unlimited polls with up to 8 items on any plan. First choose the poll type and number of items, then name your poll, select or write a question, pick a language, add your content, save and launch.
            </p>
            <div className="row g-2 align-items-start mb-3">
                <div className="col-12 col-md-4">
            <div className="d-flex flex-column mb-2">
                <strong className="text-start text-muted small fst-italic mb-1">
                    Choose Type of Poll:
                </strong>

                <div className="btn-group w-100" role="group" aria-label="Poll Type Selection">
                    <input
                        type="radio"
                        className="btn-check"
                        name="poolType"
                        id="cover-pool"
                        autoComplete="off"
                        checked={poolType === "COVER_POLL"}
                        onChange={() => setPoolType("COVER_POLL")}
                    />
                    <label className="btn btn-sm btn-outline-success" htmlFor="cover-pool">
                        Cover
                    </label>

                    <input
                        type="radio"
                        className="btn-check"
                        name="poolType"
                        id="title-pool"
                        autoComplete="off"
                        checked={poolType === "TITLE_POLL"}
                        onChange={() => setPoolType("TITLE_POLL")}
                    />
                    <label className="btn btn-sm btn-outline-success" htmlFor="title-pool">
                        Title
                    </label>

                    <input
                        type="radio"
                        className="btn-check"
                        name="poolType"
                        id="description-pool"
                        autoComplete="off"
                        checked={poolType === "DESCRIPTION_POLL"}
                        onChange={() => setPoolType("DESCRIPTION_POLL")}
                    />
                    <label className="btn btn-sm btn-outline-success" htmlFor="description-pool">
                        Description
                    </label>

                    <input
                        type="radio"
                        className="btn-check"
                        name="poolType"
                        id="cover-title-pool"
                        autoComplete="off"
                        checked={poolType === "COVER_TITLE_POLL"}
                        onChange={() => setPoolType("COVER_TITLE_POLL")}
                    />
                    <label className="btn btn-sm btn-outline-success" htmlFor="cover-title-pool">
                        Cover&Title
                    </label>

                    <input
                        type="radio"
                        className="btn-check"
                        name="poolType"
                        id="mixed-pool"
                        autoComplete="off"
                        checked={poolType === "MIXED_POLL"}
                        onChange={() => setPoolType("MIXED_POLL")}
                    />
                    <label className="btn btn-sm btn-outline-success" htmlFor="mixed-pool">
                        Mix
                    </label>
                </div>
            </div>
                </div>




            <div className="col-12 col-md-3">
            <div className="d-flex flex-column mb-2">
                <strong className="text-start text-muted small fst-italic mb-1">
                    Number of Options:
                </strong>

                <div className="btn-group w-100" role="group" aria-label="Pool Item Count Selection">
                    { [2, 3, 4, 5, 6, 7, 8].map((count) => (
                        <React.Fragment key={count}>
                            <input
                                type="radio"
                                className="btn-check"
                                name="itemCount"
                                id={`item-${count}`}
                                autoComplete="off"
                                checked={poolItemCount === count}
                                onChange={() => setPoolItemCount(count)}
                            />
                            <label
                                className={`btn btn-sm btn-outline-success ${poolItemCount === count ? 'active' : ''} 
                    ${count === 2 ? 'rounded-start' : ''} 
                    ${count === 8 ? 'rounded-end' : ''}`}
                                htmlFor={`item-${count}`}
                            >
                                {count}
                            </label>
                        </React.Fragment>
                    ))}
                </div>
            </div>
                    </div>

                    {/* Название опроса */}
                    <div className="col-12 col-md-3">
                        <div className="d-flex flex-column mb-2">
                            <strong className="text-start text-muted small fst-italic mb-1">
                                Poll Name:
                            </strong>
                            <Form className="mt-0">
                                <Form.Control
                                    className="form-control-sm p-2 border border-secondary rounded "
                                    value={poolName}
                                    onChange={e => setPoolName(e.target.value)}
                                    placeholder="Set Own Name for this Poll..."
                                    disabled={loading}
                                    style={{
                                        fontSize: '0.875rem',
                                        height: '30px',
                                    }}
                                />
                            </Form>
                        </div>
                    </div>

                    {/* Кнопка Own/Auto */}
                    <div className="col-12 col-md-2">
                        <div className="d-flex flex-column">
                            <strong className="text-start text-muted small fst-italic mt-0 mb-1">
                                {writeOwnName ? 'Auto Name:' : 'Own Name:'}
                            </strong>
                            <button
                                type="button"
                                className={`btn btn-sm mt-0 ${writeOwnName ? 'btn-success' : 'btn-outline-success'}`}
                                onClick={() => {
                                    setWriteOwnName(prev => !prev);
                                    setPoolName('');
                                }}
                                style={{ maxWidth: '380px' }}
                            >
                                {writeOwnName ? 'Use Auto' : 'Own Name'}
                            </button>
                        </div>
                    </div>
                </div>








            <div className="row g-3 mb-2">

                {/* Поле вопроса вручную */}
                <div className="col-12 col-md-8">
                    <div className="d-flex flex-column h-100">
                        <strong className="text-start text-muted small fst-italic mb-1">
                            Set Question for Respondents or use templates:
                        </strong>
                        <Form className="mb-0 flex-grow-1">
                            <Form.Control
                                className="form-control-sm p-2 border text-muted border-secondary rounded"
                                value={poolQuestion || ''}
                                onChange={e => setPoolQuestion(e.target.value)}
                                placeholder="Provide your own Question..."
                                disabled={loading}
                                style={{
                                    fontSize: '0.875rem',
                                    height: '30px',
                                    width: '100%'
                                }}
                            />
                        </Form>
                    </div>
                </div>

                {/* Шаблон */}
                <div className="col-12 col-sm-6 col-md-2">
                    <div className="d-flex flex-column h-100">
                        <strong className="text-start text-muted small fst-italic mb-1">
                            Or Use Templates:
                        </strong>
                        <Dropdown className="mb-0 w-100">
                            <Dropdown.Toggle
                                variant="light"
                                className="form-control-sm w-100 d-flex justify-content-center align-items-center"
                                style={{
                                    background: 'none',
                                    border: '1px solid',
                                    color: '#495057',
                                    fontSize: '0.875rem',
                                    padding: '0.25rem 0.5rem',
                                    height: '30px',
                                }}
                            >
                                Templates...
                            </Dropdown.Toggle>
                            <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                                {questions
                                    .filter((q) => q.type === poolType)
                                    .map((q) => (
                                        <Dropdown.Item
                                            key={q.id}
                                            className="small"
                                            onClick={() => setPoolQuestion(q.name)}
                                        >
                                            {q.short_name}
                                        </Dropdown.Item>
                                    ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>

                {/* Язык */}
                <div className="col-12 col-sm-6 col-md-2">
                    <div className="d-flex flex-column h-100">
                        <strong className="text-start text-muted small fst-italic mb-1">Language:</strong>
                        <Dropdown className="mb-0 w-100">
                            <Dropdown.Toggle
                                variant="light"
                                className="form-control-sm w-100"
                                style={{
                                    background: 'none',
                                    border: '1px solid',
                                    color: '#495057',
                                    textAlign: 'center',
                                    fontSize: '0.875rem',
                                    padding: '0.25rem 0.5rem',
                                    height: '30px'
                                }}
                            >
                                {poolLanguage || "Set Language of this Poll..."}
                            </Dropdown.Toggle>
                            <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                                {languages.map((lang) => (
                                    <Dropdown.Item
                                        key={lang.id}
                                        className="small"
                                        onClick={() => setPoolLanguage(lang.name)}
                                    >
                                        {lang.name}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>


            {/* Картинки */}
            {poolType === "COVER_POLL" && (
            <>
            <div className="row p-3 mt-0 mb-0">
                {items.slice(0, poolItemCount).map((editor, index) => (
                   <>
                   {poolType === "COVER_POLL" && (
                            <>
                                <div
                                    key={index}
                                    className={`col-12 col-sm-6 ${poolItemCount > 3 ? 'col-md-3' : poolItemCount > 2 ? 'col-md-4' : 'col-md-6'} d-flex flex-column justify-content-center align-items-center`}

                                >

                                {/* Карточка с тенью */}
                            <div className="card text-center align-content-center shadow-sm mb-3 p-1" style={{ width: '100%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                    <div style={{ width: '28px' }}></div> {/* Заглушка слева */}

                                    <h6 className="text-muted fst-italic p-2 m-0 text-center" style={{ flex: 1 }}>
                                        Cover Image #{index + 1}
                                    </h6>

                                    <div style={{ width: '28px', display: 'flex', justifyContent: 'center' }}>
                                        {editor.originalFile && (
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm d-flex align-items-center justify-content-center"
                                                onClick={() => handleDelete(index)}
                                                style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '50%',
                                                    padding: '0',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <i className="bi bi-x" style={{ fontSize: '16px' }}></i>
                                            </button>
                                        )}
                                    </div>
                                </div>



                                {editor.showEditor ? (
                                <AvatarEditor
                                    ref={(ref) => {
                                        if (ref) editorRefs.current[index] = ref;
                                    }}
                                    image={editor.preview}
                                    width={editor.editorSize.width} // Используем обновлённые размеры
                                    height={editor.editorSize.height} // Используем обновлённые размеры
                                    border={0}
                                    scale={editor.scale}
                                    className="text-center mb-0 mt-0 m-auto rounded"
                                    style={{ maxWidth: '200px', height: 'auto' }} // Ограничиваем максимальную ширину
                                />
                            ) : (
                                  <div className="mb-3" style={{ position: 'relative', display: 'inline-block', margin: '0 auto' }}>
                                      <img
                                          src={editor.preview}
                                          alt={`Preview ${index + 1}`}
                                          style={{
                                              objectFit: 'cover',
                                              maxWidth: '200px',
                                              height: 'auto',
                                              borderRadius: '8px',
                                              opacity: editor.originalFile ? 1.0 : 0.5, // если есть файл — opacity 1.0, иначе 0.5
                                              display: 'block',
                                          }}
                                      />
                                      {!editor.originalFile && (
                                          <>
                                              <button
                                                  type="button"
                                                  className="btn btn-sm btn-success"
                                                  onClick={() => document.getElementById(`fileInput-${index}`).click()}
                                                  style={{
                                                      position: 'absolute',
                                                      top: '50%',
                                                      left: '50%',
                                                      transform: 'translate(-50%, -50%)',
                                                      padding: '6px 12px',
                                                      borderRadius: '5px',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      gap: '6px',
                                                  }}
                                                  disabled={index > 0 && !items[index - 1]?.flag}

                                              >
                                                  <i className="bi bi-upload"></i> Upload
                                              </button>

                                          </>
                                          )}
                                  </div>
                              )}


                            <input
                                type="file"
                                style={{ display: "none" }}
                                id={`fileInput-${index}`}
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, index)}
                            />

                            {editor.showEditor && (activeIndex === index) && (
                                <>
                                    <div className={"mt-1 d-flex flex-column align-items-center"}>
                                        <span className="text-center text-muted fst-italic small mt-2">Set Zoom & Cover Size:</span>
                                    </div>
                                    {/* Зумер с отступами и шириной */}
                                    <div className="mt-3 mb-3 d-flex justify-content-center align-items-center">
                                        <i className="bi bi-dash-circle-fill text-success me-2" style={{ fontSize: '1.2rem' }}></i>
                                        <input
                                            type="range"
                                            min="1"
                                            max="2"
                                            step="0.01"
                                            value={editor.scale}
                                            style={{ width: '150px' }}
                                            onChange={(e) => handleScaleChange(e, index)}
                                        />
                                        <i className="bi bi-plus-circle-fill text-success ms-2" style={{ fontSize: '1.2rem' }}></i>
                                    </div>

                                    {/* Выбор формата книги и кнопка сохранения в одну строку */}
                                    {activeIndex === index && (
                                        <>
                                            <div className="d-flex align-items-center justify-content-center mb-2 gap-2">
                                                <i className="bi bi-arrows-angle-expand text-success" style={{ fontSize: '1.5rem' }}></i>

                                                <select
                                                    id={`format-select-${index}`}
                                                    value={editor.format}
                                                    onChange={(e) => handleFormatChange(index, e.target.value)}
                                                    className="form-select w-auto form-select-sm"
                                                    style={{ minWidth: "50px" }}
                                                >
                                                    <option value="6x9">6x9 (2x3)</option>
                                                    <option value="8.5x11">8.5x11</option>
                                                    <option value="8.5x8.5">8.5x8.5 (1x1)</option>
                                                    <option value="8x10">8x10</option>
                                                    <option value="5x8">5x8</option>
                                                    <option value="7x10">7x10</option>
                                                </select>

                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-success"
                                                    onClick={() => handleSave(index)}
                                                >
                                                    Save
                                                </button>
                                            </div>

                                        </>
                                    )}

                                </>
                            )}

                            </div>
                                {/* Конец карточки */}
                            </div>
                            </>
                            )}

                   </>
                ))}
            </div>
            </>
            )}
            {/* title */}
            {poolType === "TITLE_POLL" && (
                <>
            <div className="row p-3 mt-0 mb-0">
                {poolType === "TITLE_POLL" && items.slice(0, poolItemCount).map((item, index) => (
                    <div
                        key={index}
                        className={`col-12 col-sm-6 ${poolItemCount > 3 ? 'col-md-3' : poolItemCount > 2 ? 'col-md-4' : 'col-md-6'} d-flex flex-column justify-content-center align-items-center`}

                    >
                        <div className="card text-center align-content-center shadow-sm mb-3 p-2" style={{ width: '100%' }}>
                            <h6 className="mx-auto text-muted fst-italic ">Title Text #{index + 1}</h6>

                            <div className="d-flex flex-column p-1" style={{ flex: 1 }}>
                                <strong className="text-start text-muted small fst-italic mb-1">
                                    Set Title and Subtitle:
                                </strong>
                                <form className="mt-1 w-100 d-flex justify-content-center">
  <textarea
      rows={2}
      className="form-control form-control-sm p-2 border border-secondary rounded"
      value={item.title}
      onChange={e => {
          const updatedItems = [...items];
          updatedItems[index].title = e.target.value;
          updatedItems[index].flag = true; // устанавливаем флаг в true при изменении текста
          setItems(updatedItems);
          e.target.style.height = "auto"; // сначала сбрасываем
          e.target.style.height = e.target.scrollHeight + "px"; // затем устанавливаем новую высоту
      }}
      placeholder="Enter title... Example: Title of the Book: Subtitle of the Book"
      disabled={loading}
      style={{
          fontSize: '0.875rem',
          minHeight: '30px',
          resize: 'none', // чтобы пользователь не растягивал руками
          overflow: 'hidden', // убираем полосы прокрутки
          width: '100%',
      }}
  />
                                </form>

                                <strong className="text-start text-muted small fst-italic mt-3 mb-1">
                                    Set Pen Name (Author) for this Title:
                                </strong>
                                <form className="mt-1 w-100 d-flex justify-content-center">
  <textarea
      rows={1}
      className="form-control form-control-sm p-2 border border-secondary rounded"
      value={item.pn}
      onChange={e => {
          const updatedItems = [...items];
          updatedItems[index].pn = e.target.value;
          setItems(updatedItems);
          e.target.style.height = "auto"; // сначала сбрасываем
          e.target.style.height = e.target.scrollHeight + "px"; // затем устанавливаем новую высоту
      }}
      placeholder="Enter Author (Pen Name) for this Title..."
      disabled={loading}
      style={{
          fontSize: '0.875rem',
          minHeight: '30px',
          resize: 'none', // чтобы пользователь не растягивал руками
          overflow: 'hidden', // убираем полосы прокрутки
          width: '100%',
      }}
  />
                                </form>

                            </div>
                        </div>
                    </div>
                ))}
            </div>
                </>
            )}
            {/* Описания */}
            {poolType === "DESCRIPTION_POLL" && (
                <>
            <div className="row p-3 mt-0 mb-0">
                {poolType === "DESCRIPTION_POLL" && items.slice(0, poolItemCount).map((item, index) => (
                    <div
                        key={index}
                        className={`col-12 col-sm-6 ${poolItemCount > 3 ? 'col-md-3' : poolItemCount > 2 ? 'col-md-4' : 'col-md-6'} d-flex flex-column justify-content-center align-items-center`}

                    >
                        <div className="card text-center align-content-center shadow-sm mb-3 p-2" style={{ width: '100%' }}>
                            <h6 className="mx-auto text-muted fst-italic ">Description Text #{index + 1}</h6>

                            <div className="d-flex flex-column p-1" style={{ flex: 1 }}>
                                <strong className="text-start text-muted small fst-italic mb-1">
                                    Set Description Text:
                                </strong>
                                <form className="mt-1 w-100 d-flex justify-content-center">
  <textarea
      rows={3}
      className="form-control form-control-sm p-2 border border-secondary rounded"
      value={item.desc}
      onChange={e => {
          const updatedItems = [...items];
          updatedItems[index].desc = e.target.value;
          updatedItems[index].flag = true;
          setItems(updatedItems);
          e.target.style.height = "auto"; // сначала сбрасываем
          e.target.style.height = e.target.scrollHeight + "px"; // затем устанавливаем новую высоту
      }}
      placeholder="Enter Description..."
      disabled={loading}
      style={{
          fontSize: '0.875rem',
          minHeight: '30px',
          resize: 'none', // чтобы пользователь не растягивал руками
          overflow: 'hidden', // убираем полосы прокрутки
          width: '100%',
      }}
  />
                                </form>
                         </div>
                        </div>
                    </div>
                ))}
            </div>
                </>
            )}
            {/* Mixed */}
            {(poolType === "MIXED_POLL" || poolType === "COVER_TITLE_POLL") && (
                <>
                    <div className="row p-3 mt-0 mb-0">
                        {items.slice(0, poolItemCount).map((item, index) => (
                            <>
                                {(poolType === "MIXED_POLL" || poolType === "COVER_TITLE_POLL") && (
                                    <>
                                        <div
                                            key={index}
                                            className={`col-12 col-sm-6 ${poolItemCount > 3 ? 'col-md-3' : poolItemCount > 2 ? 'col-md-4' : 'col-md-6'} d-flex flex-column justify-content-center align-items-center`}

                                        >

                                            {/* Карточка с тенью */}
                                            <div className="card text-center align-content-center shadow-sm mb-3 p-1" style={{ width: '100%' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                    <div style={{ width: '28px' }}></div> {/* Заглушка слева */}

                                                    <h6 className="text-muted fst-italic p-2 m-0 text-center" style={{ flex: 1 }}>
                                                        Cover Image #{index + 1}
                                                    </h6>

                                                    <div style={{ width: '28px', display: 'flex', justifyContent: 'center' }}>
                                                        {item.originalFile && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm d-flex align-items-center justify-content-center"
                                                                onClick={() => handleDelete(index)}
                                                                style={{
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    borderRadius: '50%',
                                                                    padding: '0',
                                                                    flexShrink: 0,
                                                                }}
                                                            >
                                                                <i className="bi bi-x" style={{ fontSize: '16px' }}></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>



                                                {item.showEditor ? (
                                                    <AvatarEditor
                                                        ref={(ref) => {
                                                            if (ref) editorRefs.current[index] = ref;
                                                        }}
                                                        image={item.preview}
                                                        width={item.editorSize.width} // Используем обновлённые размеры
                                                        height={item.editorSize.height} // Используем обновлённые размеры
                                                        border={0}
                                                        scale={item.scale}
                                                        className="text-center mb-0 mt-0 m-auto rounded"
                                                        style={{ maxWidth: '200px', height: 'auto' }} // Ограничиваем максимальную ширину
                                                    />
                                                ) : (
                                                    <div className="mb-3" style={{ position: 'relative', display: 'inline-block', margin: '0 auto' }}>
                                                        <img
                                                            src={item.preview}
                                                            alt={`Preview ${index + 1}`}
                                                            style={{
                                                                objectFit: 'cover',
                                                                maxWidth: '200px',
                                                                height: 'auto',
                                                                borderRadius: '8px',
                                                                opacity: item.originalFile ? 1.0 : 0.5, // если есть файл — opacity 1.0, иначе 0.5
                                                                display: 'block',
                                                            }}
                                                        />
                                                        {!item.originalFile && (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-success"
                                                                    onClick={() => document.getElementById(`fileInput-${index}`).click()}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '50%',
                                                                        left: '50%',
                                                                        transform: 'translate(-50%, -50%)',
                                                                        padding: '6px 12px',
                                                                        borderRadius: '5px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '6px',
                                                                    }}
                                                                    disabled={index > 0 && !items[index - 1]?.flag}
                                                                >
                                                                    <i className="bi bi-upload"></i> Upload
                                                                </button>

                                                            </>
                                                        )}
                                                    </div>
                                                )}


                                                <input
                                                    type="file"
                                                    style={{ display: "none" }}
                                                    id={`fileInput-${index}`}
                                                    accept="image/*"
                                                    onChange={(e) => handleFileChange(e, index)}
                                                />

                                                {item.showEditor && (activeIndex === index) && (
                                                    <>
                                                        <div className={"mt-1 d-flex flex-column align-items-center"}>
                                                            <span className="text-center text-muted fst-italic small mt-2">Set Zoom & Cover Size:</span>
                                                        </div>
                                                        {/* Зумер с отступами и шириной */}
                                                        <div className="mt-3 mb-3 d-flex justify-content-center align-items-center">
                                                            <i className="bi bi-dash-circle-fill text-success me-2" style={{ fontSize: '1.2rem' }}></i>
                                                            <input
                                                                type="range"
                                                                min="1"
                                                                max="2"
                                                                step="0.01"
                                                                value={item.scale}
                                                                style={{ width: '150px' }}
                                                                onChange={(e) => handleScaleChange(e, index)}
                                                            />
                                                            <i className="bi bi-plus-circle-fill text-success ms-2" style={{ fontSize: '1.2rem' }}></i>
                                                        </div>

                                                        {/* Выбор формата книги и кнопка сохранения в одну строку */}
                                                        {activeIndex === index && (
                                                            <>
                                                                <div className="d-flex align-items-center justify-content-center mb-2 gap-2">
                                                                    <i className="bi bi-arrows-angle-expand text-success" style={{ fontSize: '1.5rem' }}></i>

                                                                    <select
                                                                        id={`format-select-${index}`}
                                                                        value={item.format}
                                                                        onChange={(e) => handleFormatChange(index, e.target.value)}
                                                                        className="form-select w-auto form-select-sm"
                                                                        style={{ minWidth: "50px" }}
                                                                    >
                                                                        <option value="6x9">6x9 (2x3)</option>
                                                                        <option value="8.5x11">8.5x11</option>
                                                                        <option value="8.5x8.5">8.5x8.5 (1x1)</option>
                                                                        <option value="8x10">8x10</option>
                                                                        <option value="5x8">5x8</option>
                                                                        <option value="7x10">7x10</option>
                                                                    </select>

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-success"
                                                                        onClick={() => handleSave(index)}
                                                                    >
                                                                        Save
                                                                    </button>
                                                                </div>

                                                            </>
                                                        )}

                                                    </>
                                                )}

                                                {/* Контейнер для кнопок */}
                                                {(poolType === "MIXED_POLL" || poolType === "COVER_TITLE_POLL") && (
                                                    <>
                                                      <div className="d-flex flex-column p-1" style={{ flex: 1 }}>
                                                            <strong className="text-start text-muted small fst-italic mb-1">
                                                                Set Title and Subtitle:
                                                            </strong>
                                                            <form className="mt-1 w-100 d-flex justify-content-center">
  <textarea
      rows={2}
      className="form-control form-control-sm p-2 border border-secondary rounded"
      value={item.title}
      onChange={e => {
          const updatedItems = [...items];
          updatedItems[index].title = e.target.value;
          setItems(updatedItems);
          e.target.style.height = "auto"; // сначала сбрасываем
          e.target.style.height = e.target.scrollHeight + "px"; // затем устанавливаем новую высоту
      }}
      placeholder="Enter title... Example: Title of the Book: Subtitle of the Book"
      disabled={loading}
      style={{
          fontSize: '0.875rem',
          minHeight: '30px',
          resize: 'none', // чтобы пользователь не растягивал руками
          overflow: 'hidden', // убираем полосы прокрутки
          width: '100%',
      }}
  />
                                                            </form>

                                                            <strong className="text-start text-muted small fst-italic mt-3 mb-1">
                                                                Set Author Name:
                                                            </strong>
                                                            <form className="mt-1 w-100 d-flex justify-content-center">
  <textarea
      rows={1}
      className="form-control form-control-sm p-2 border border-secondary rounded"
      value={item.pn}
      onChange={e => {
          const updatedItems = [...items];
          updatedItems[index].pn = e.target.value;
          setItems(updatedItems);
          e.target.style.height = "auto"; // сначала сбрасываем
          e.target.style.height = e.target.scrollHeight + "px"; // затем устанавливаем новую высоту
      }}
      placeholder="Enter Author (Pen Name)..."
      disabled={loading}
      style={{
          fontSize: '0.875rem',
          minHeight: '30px',
          resize: 'none', // чтобы пользователь не растягивал руками
          overflow: 'hidden', // убираем полосы прокрутки
          width: '100%',
      }}
  />
                                                            </form>

                                                        </div>
</>
                                                )}
                                                      {(poolType === "MIXED_POLL") && (
                                                          <>
                                                        <div className="d-flex flex-column p-1" style={{ flex: 1 }}>
                                                            <strong className="text-start text-muted small fst-italic mt-2 mb-1">
                                                                Set Description Text:
                                                            </strong>
                                                            <form className="mt-1 w-100 d-flex justify-content-center">
  <textarea
      rows={3}
      className="form-control form-control-sm p-2 border border-secondary rounded"
      value={item.desc}
      onChange={e => {
          const updatedItems = [...items];
          updatedItems[index].desc = e.target.value;
          setItems(updatedItems);
          e.target.style.height = "auto"; // сначала сбрасываем
          e.target.style.height = e.target.scrollHeight + "px"; // затем устанавливаем новую высоту
      }}
      placeholder="Enter Description..."
      disabled={loading}
      style={{
          fontSize: '0.875rem',
          minHeight: '30px',
          resize: 'none', // чтобы пользователь не растягивал руками
          overflow: 'hidden', // убираем полосы прокрутки
          width: '100%',
      }}
  />
                                                            </form>
                                                        </div>
                                                    </>

                                                )}
                                            </div>
                                            {/* Конец карточки */}
                                        </div>
                                    </>
                                )}

                            </>
                        ))}
                    </div>
                </>
            )}




            <div className="d-flex align-items-end gap-3 ms-auto me-3 mb-3">
                <button
                    type="button"
                    className="btn btn-sm btn-success"
                    onClick={() => addPool()}
                >
                    Save this Poll
                </button>
            </div>


        </div>

    );
};

export default CreatePool;
